import { API } from 'aws-amplify';

export type PutMapStatusInput = {
  student_id: string;
  subject: string;
};

export async function putMapStatus(input: PutMapStatusInput): Promise<any> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = `api/testing/map/status`;
    const myInit = {
      headers: {},
      body: input,
    };
    return await API.put(apiName, path, myInit);
  } catch (error) {
    console.error('Error updating map status:', error);
    throw error;
  }
}
